
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/bundles/[courseBundleId]",
      function () {
        return require("private-next-pages/courses/bundles/[courseBundleId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/bundles/[courseBundleId]"])
      });
    }
  